import React, { useEffect, useState } from "react";

// Bootstrap If Required
import { Tab, Nav, Row, Col } from "react-bootstrap";
import firebase from "../../firestore";

const MultiTab = (props) => {
  let userDetails = props.userDetails
  return (
    <div className="MultiTab_Dashboard">
      <Tab.Container
        id="left-tabs-example"
        className="dashboardTabs"
        defaultActiveKey="first"
      >
        <Row>
          <Col lg={5} sm={12} xs={12}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item className="eachPill">
                <Nav.Link eventKey="first">Basic Details</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Education</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="third">Work Experience</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="fourth">Projects</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col lg={7} sm={12} xs={12} className="rightTab1">
            <Tab.Content>
              <Tab.Pane eventKey="first" className="eachTabDetail">
                <div className="detailsPanel">
                  <span>
                    <h4>Name : </h4> <p>{userDetails.name}</p>
                  </span>
                  <span>
                    <h4>Tagline : </h4> <p>{userDetails.tagline}</p>
                  </span>
                  <span>
                    <h4>Email : </h4> <p>{userDetails.email} <span style={{ fontSize: "0.8rem", color: "red" }}>[This email will be used as a means of communication]</span> </p>
                  </span>
                  <span>
                    <h4>Resume Link : </h4> <a href={userDetails.resume} target="_blank" rel="noreferrer noopener">Link</a>
                  </span>
                  <span>
                    <h4>Phone : </h4> <p>{userDetails.phone}</p>
                  </span>
                  <span>
                    <h4>About me </h4> <br /> <p>{userDetails.about}</p>
                  </span>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="second" className="eachTabDetail">
                <div className="detailsPanel">
                  <div className="separator">
                    <span>
                      <h4>College : </h4>{" "}
                      <p>{userDetails.education.grad.instName}</p>
                    </span>
                    <span>
                      <h4>Course : </h4>{" "}
                      <p>{userDetails.education.grad.progname}</p>
                    </span>
                    <span>
                      <h4>State : </h4> <p>{userDetails.education.grad.state}</p>
                    </span>
                    <span>
                      <h4>Year of Passing : </h4>{" "}
                      <p>{userDetails.education.grad.yop}</p>
                    </span>
                    <span>
                      <h4>University : </h4>{" "}
                      <p>{userDetails.education.grad.univ}</p>
                    </span>
                  </div>

                  <div className="separator">
                    <span>
                      <h4>HSSC/Diploma : </h4>{" "}
                      <p>{userDetails.education.hssc.instName}</p>
                    </span>
                    <span>
                      <h4>Stream : </h4> <p>{userDetails.education.hssc.stream}</p>
                    </span>
                    <span>
                      <h4>State : </h4> <p>{userDetails.education.hssc.state}</p>
                    </span>
                    <span>
                      <h4>Year of Passing : </h4>{" "}
                      <p>{userDetails.education.hssc.yop}</p>
                    </span>
                    <span>
                      <h4>Board : </h4>{" "}
                      <p>{userDetails.education.hssc.univ}</p>
                    </span>
                  </div>

                  <div className="separator">
                    <span>
                      <h4>SSC : </h4> <p>{userDetails.education.ssc.instName}</p>
                    </span>
                    <span>
                      <h4>State : </h4> <p>{userDetails.education.ssc.state}</p>
                    </span>
                    <span>
                      <h4>Year of Passing : </h4>{" "}
                      <p>{userDetails.education.ssc.yop}</p>
                    </span>
                    <span>
                      <h4>Board : </h4>{" "}
                      <p>{userDetails.education.ssc.univ}</p>
                    </span>
                  </div>

                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="third" className="eachTabDetail">
                <div className="detailsPanel">
                  {userDetails.companyDetails
                    ? userDetails.companyDetails.map((item) => {
                      return (
                        <div className="separator">
                          <span>
                            <h4>Company : </h4>
                            <p>{item.name}</p>
                          </span>
                          <span>
                            <h4>Position : </h4> <p>{item.role}</p>
                          </span>
                          <span>
                            <h4>From : </h4> <p>{item.from}</p>
                          </span>
                          <span>
                            <h4>  To : </h4> <p>{item.to}</p>
                          </span>
                        </div>

                      );
                    })
                    : null}
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="fourth" className="eachTabDetail">
                <div className="detailsPanel">
                  {userDetails.project
                    ? userDetails.project.map((item) => {
                      return (
                        <div className="separator">
                          <span><h4>Project Name : </h4> <p>{item.name}</p></span>
                          <span><h4>Description : </h4><p>{item.desc}</p></span>
                          <span><a href={item.link} target="_blank" rel="noreferrer noopener">Project Link</a></span>

                        </div>

                      );
                    })
                    : null}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default MultiTab;
